define(function (require) {
	// models
	const IpsModel = require('civicsBase/ipsModel');
	// collections
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const CodeDefinitionCollection = require('civicsCollections/code_definition_collection');

	const ViewManager = require('civicsUtils/view_manager');

	return {
		//fetch the options from the server.
		_fetchOptions: function (moniker, removeNoneOptions = false) {
			var optionFetchPromise = $.Deferred();
			if (!_.isEmpty(moniker)) {
				var optionsCollection = new CodeDefinitionCollection();
				optionsCollection.moniker = moniker;
				optionsCollection.removeNoneOptions = removeNoneOptions;
				var self = this;
				optionsCollection.fetch({
					error: function (model, response, options) {
						ViewManager.errorToWindow(response, this);
					}
				}).done(function (response, status, xhrResponse) {
					let resp = response.data.codeDescriptionItems;
					if (removeNoneOptions) {
						resp = response.data.codeDescriptionItems.filter((item) => {
							return item.code != 'None';
						})
					}
					optionFetchPromise.resolve(resp);
				});
			}
			return optionFetchPromise;
		},
		//returns the description that matches a code
		getDescription: function (detailPageId, fieldMoniker, tableMoniker, code) {
			if (tableMoniker == null) {
				tableMoniker = 'noTable';
			}
			var ret = '';
			var options = this.getOptions(detailPageId, fieldMoniker, tableMoniker);
			$.each(options, function (index, el) {
				if (el.code == code) {
					ret = el.description;
					//break out of loop
					return false;
				}
			});
			return ret;
		},
		//returns options from storage, or null if they don't exist
		//Always call load options FIRST if there's any chance the options haven't been loaded yet.
		getOptions: function (detailPageId, fieldMoniker, tableMoniker, code) {
			var ret = null;
			if (tableMoniker == null) {
				tableMoniker = 'noTable';
			}
			var $storageDiv = $('body > #storedOptions');
			if ($storageDiv.length == 1) {
				var storedOptions = $storageDiv.data('storedOptions');
				if (storedOptions != null && storedOptions[detailPageId] != null && storedOptions[detailPageId][tableMoniker] != null) {
					if (storedOptions[detailPageId][tableMoniker][fieldMoniker] != null) {
						ret = $.extend(true, [], storedOptions[detailPageId][tableMoniker][fieldMoniker]);
					} else if (storedOptions[detailPageId][tableMoniker][fieldMoniker + '_promise'] != null) {
						//check for a stored promise object
						ret = storedOptions[detailPageId][tableMoniker][fieldMoniker + '_promise'];
					}
				}
			}
			if (code != null && ret != null) {
				$.each(ret, function (index, el) {
					if (el.code == code) {
						el.selected = true;
						//break out of loop
						return false;
					}
				});
			}
			return ret;
		},
		//loads options for specific detail page/table/field. Returns a promise.
		loadOptions: function (detailPageId, fieldMoniker, tableMoniker, removeNoneOptions = false) {
			if (tableMoniker == null) {
				tableMoniker = 'noTable';
			}
			var optionsReadyPromise = $.Deferred();
			var options = this.getOptions(detailPageId, fieldMoniker, tableMoniker);
			//get Options will return a promise object if a previous DDL started a fetch that hasn't completed yet
			//if options.promise exists, wait for it to resolve before resolving optionsReadyPromise. No need to fire a nother fetch
			if (options != null && options.promise) {
				$.when(options).done(function () {
					optionsReadyPromise.resolve({'loadedFromCache':false});
				});
			} else if (options != null) {//if it's not a promise, and it's not null, it must be our options
				optionsReadyPromise.resolve({'loadedFromCache':true});
			} else {//If it's null, it's time to fetch some data.
				//store a promise object.
				var storedPromise = $.Deferred();
				this.storeOptions(detailPageId, fieldMoniker + '_promise', tableMoniker, storedPromise);
				var fetchPromise = this._fetchOptions(fieldMoniker, removeNoneOptions);
				var self = this;
				$.when(fetchPromise).done(function (opts) {
					self.storeOptions(detailPageId, fieldMoniker, tableMoniker, opts);
					optionsReadyPromise.resolve({'loadedFromCache':false});
				});
			}
			return optionsReadyPromise;
		},
		storeOptions: function (detailPageId, fieldMoniker, tableMoniker, options) {
			/*Data is stored on a div on the body element like so:
			storedOptions:{
				detailPageID:{
					tableName:{
						fieldName:[
							{
								code:code_value,
								description:description_value
							}
						]
					}
				}
			}*/
			if (tableMoniker == null) {
				tableMoniker = 'noTable';
			}
			if ($('body > #storedOptions').length == 0) {
				$('body').append($('<div/>', {
					'id': 'storedOptions',
					'style': 'display="none"'
				}));
			}
			var $storageDiv = $('body > #storedOptions');
			if (_.isArray(options) && options.length > 0 && options[0].text != null) {
				//we sometimes need to store valueSelections. ValueSelections have a text and value attribute for each
				//option, instead of a code and description like Hansen Code Definitions. We convert them here.
				var converted = [];
				$.each(options, function (index, el) {
					var option = {
						code: el.value,
						description: el.text
					};
					converted.push(option);
				});
				options = converted;
			}
			//var $detailContainer =$('[data-detailpageid="'+detailPageId+'"]');

			var storedOptions = $storageDiv.data('storedOptions');
			if (storedOptions == null) {
				storedOptions = {};
			}
			var detailOptions = storedOptions[detailPageId] != null ? storedOptions[detailPageId] : {};
			var tableOptions = detailOptions[tableMoniker] != null ? detailOptions[tableMoniker] : {};
			var fieldOptions = options;
			tableOptions[fieldMoniker] = fieldOptions;
			detailOptions[tableMoniker] = tableOptions;
			storedOptions[detailPageId] = detailOptions;

			//save updated data back
			$storageDiv.data('storedOptions', storedOptions);

			//if we previously added a spot for a promise to be saved for this field moniker, resolve that promise.
			if (tableOptions[fieldMoniker + '_promise'] && tableOptions[fieldMoniker + '_promise'].state() != 'resolved') {
				tableOptions[fieldMoniker + '_promise'].resolve();
			}
		},
		//state here all conditions for number fields in detail pages
		numberFields: function (model, config) {
		  var number = {}
		  number.isZeroValue = {
		      condition: (model.get('value') == 0 && !config.readOnlyForm),
		      value: ''
		    };
			number.decimalPlaces = {
					 condition: (model.get('value') > 0 && model.get('decimalplaces') > 0),
					 value: parseFloat(model.get('value')).toFixed(model.get('decimalplaces'))
				 };
		  return number;
		},

	};
});
